/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Dashboards_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Dashboards from this project's linked datasets appear here." |
*
* @param {Project_Dashboards_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_dashboards_empty_description = /** @type {((inputs?: Project_Dashboards_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Dashboards_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboards aus den verknüpften Datensätzen dieses Projekts erscheinen hier.")
	return /** @type {LocalizedString} */ ("Dashboards from this project's linked datasets appear here.")
});